import { createStore, applyMiddleware } from "redux";
import reducer from "reducers";
import thunk from "redux-thunk";
import api from "middleware/api";
import routeHistory from "middleware/route-history";
import multi from "middleware/multi";
import featureFlags from "middleware/feature-flags";
import { connectRouter, routerMiddleware } from "connected-react-router";
import { createBrowserHistory } from "history";
import { storage } from "services/storage";
import pick from "lodash.pick";

export const history = createBrowserHistory();

const store = createStore(
  connectRouter(history)(reducer),

  // eslint-disable-next-line no-underscore-dangle
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),

  applyMiddleware(
    thunk,
    api,
    multi,
    routeHistory,
    routerMiddleware(history),
    featureFlags
  )
);


const noticesStorage = (notices) => {
  const keysToStore = ["isVisible"];

  return notices
    .map(value => pick(value.toObject(), ...keysToStore))
    .toJS();
};

store.subscribe(() => {
  const { notices, warnings } = store.getState();
  storage.store("notices", noticesStorage(notices));
  storage.store("warnings", warnings);
});

export default store;
